import { bool, number, oneOfType, shape, string } from 'prop-types';

export const templateType = shape({
  body: string,
  header: string,
  id: oneOfType([number, string]),
  new: bool, // optional
  type: string,
});
